

import { coreColors, sectionTextStyle, subSectionHeaderStyle } from '../../../styles/shared/variables';

export const desktopContentContainerPaperStyle = {
    borderRadius: '20px'
}
export const desktopHeaderDropdownStyleContainer = {
    textAlign: 'center',
    marginTop: '40px',
    marginBottom: '40px'
}

export const desktopSubjectdescriptionContainerStyle = {
    textAlign: 'center',
    fontSize: '14px',
    width: '75%',
    marginLeft: '12.5%',
    marginRight: '12.5%'
}
export const desktopContentContainerPaperDivStyle = {
    width: '90%',
    marginLeft: '5%',
    marginRight: '5%',
    marginTop: '50px',
    marginBottom: '50px'
}

export const courseHeaderStyle = {
    textAlign: 'center'
}

export const desktopCourseNumberTitleStyle = {
    fontSize: subSectionHeaderStyle.fontSize,
    color: subSectionHeaderStyle.color,
    weight: subSectionHeaderStyle.weight
}

export const desktopCourseTextTitleStyle = {
    fontSize: subSectionHeaderStyle.fontSize,
    color: coreColors.grey400,
    weight: subSectionHeaderStyle.weight
}

export const selectedCourseMainContainerStyle = {
    background: coreColors.blue300,
    marginTop: '20px',
    marginBottom: '20px',
    border: '3px outset ' + coreColors.blue200,
    borderRadius: '10px'
}

export const courseNumberAndTextSelectedStyle = {
    fontSize: subSectionHeaderStyle.fontSize,
    color: '#fff',
    weight: subSectionHeaderStyle.weight
}

export const desktopDropdownContainerStyle = {
    textAlign: 'center',
    margin: 10
}

export const desktopFormControlStyle = {
    width: '200px'
}


// WEBPACK FOOTER //
// ./src/components/course/styles/desktop.js